<template>
  <div v-if="policyPrepare" >
    <div class="d-flex justify-content-between align-items-center pt-50 mb-2">
      <h2 class="font-weight-bolder m-0">
        <span @click="$router.go(-1)">
          <b-button
              variant="white"
              class="btn-icon rounded-circle mr-50 text-primary bg-white"
              size="sm"
          >
            <feather-icon icon="ChevronLeftIcon" />
          </b-button>
        </span>
        Política de registro horario
      </h2>
    </div>
    <b-card>
        <div v-html="content" >
        </div>
        <div v-if="files.length" >
          <h4 class="mb-1">Archivo</h4>
          <div v-for="file in files" :key="file.name" class="mb-1">
            <a :href="file.url" target="_blank">{{ file.name }}</a>
          </div>
        </div>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  BButton, BForm, BFormGroup, BRow, BCol, BCard, BFormTextarea,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import FileDropzone from '@/components/elements/FileDropzone/FileDropzone.vue'
import { quillEditor } from 'vue-quill-editor'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BRow,
    BCol,
    BCard,
    FileDropzone,
    ValidationProvider,
    ValidationObserver,
    quillEditor
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      policyPrepare: false,
      content: '',
      files: [],
      profileFile: null,
    }
  },
  computed: {
    ...mapGetters({
      policy: 'config/getPolicy',
      currentClient: 'clients/getCurrentClient'
    }),
  },
  methods: {
    ...mapActions({
      getPolicy: 'config/getPolicy'
    }),
    setData() {
      if (this.policy.files_policy !== undefined && this.policy.files_policy !== null && this.policy.files_policy) {
        const files = []
        this.policy.files_policy.forEach(element => {
          const file = {
            name: element,
            url: element,
            urlDelete: '',
          }
          files.push(file)
        })
        this.files = files
      }
      this.content = this.policy.content_policy
      this.policyPrepare = true
    },
  },
  async created() {
    await this.getPolicy(this.currentClient.id)
    await this.setData()
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
